import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppUpdateService } from '../../services/app-update.service';

@Component({
  selector: 'app-update-banner',
  template: `
    @if (updateService.updateAvailable()) {
      <div class="update-banner">
        <div class="update-content">
          <span class="update-message">A new version is available - Click to update</span>
          <button class="update-button" (click)="onUpdateClick()">
            Update Now
          </button>
        </div>
      </div>
    }
  `,
  styles: [`
    .update-banner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background-color: #2196F3;
      color: white;
      z-index: 1000;
      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .update-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 20px;
      max-width: 1200px;
      margin: 0 auto;
    }

    .update-message {
      font-size: 14px;
      font-weight: 500;
    }

    .update-button {
      background-color: white;
      color: #2196F3;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .update-button:hover {
      background-color: #f5f5f5;
      transform: translateY(-1px);
    }

    .update-button:active {
      transform: translateY(0);
    }

    @media (max-width: 768px) {
      .update-content {
        flex-direction: column;
        gap: 8px;
        text-align: center;
      }
      
      .update-button {
        width: 100%;
        max-width: 200px;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateBannerComponent {
  protected updateService = inject(AppUpdateService);

  onUpdateClick(): void {
    this.updateService.applyUpdate();
  }
}